
export const UI_STATE_COLORS = {
  NORMAL: {
    bg: 'bg-primary/5',
    border: 'border-primary/30',
    text: 'text-primary',
    textLight: 'text-primary/70',
    buttonBg: 'bg-primary',
    buttonHover: 'hover:bg-primary/90',
    iconBg: 'bg-primary/15',
    iconText: 'text-primary',
  },
  EMERGENCY: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-900',
    textLight: 'text-red-700',
    buttonBg: 'bg-red-500',
    buttonHover: 'hover:bg-red-600',
    iconBg: 'bg-red-200',
    iconText: 'text-red-700',
  },
  INFO: {
    bg: 'bg-primary/5',
    border: 'border-primary/30',
    text: 'text-primary',
    textLight: 'text-primary/70',
    buttonBg: 'bg-primary',
    buttonHover: 'hover:bg-primary/90',
    iconBg: 'bg-primary/15',
    iconText: 'text-primary',
  },
};
